// Best-effort browser geolocation. Never throws, never blocks a punch.
// Caches the last fix for the session so we don't re-prompt on every punch.
let _cached = null;
let _cachedAt = 0;
const TTL = 5 * 60 * 1000; // 5 min

export function getCoords({ timeout = 6000 } = {}) {
  return new Promise((resolve) => {
    if (_cached && Date.now() - _cachedAt < TTL) {
      resolve(_cached);
      return;
    }
    if (!("geolocation" in navigator)) {
      resolve(null);
      return;
    }
    let done = false;
    const finish = (val) => {
      if (done) return;
      done = true;
      resolve(val);
    };
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        _cached = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        _cachedAt = Date.now();
        finish(_cached);
      },
      () => finish(null),
      { enableHighAccuracy: false, timeout, maximumAge: TTL }
    );
    // hard fallback so a stuck prompt never blocks the UI
    setTimeout(() => finish(null), timeout + 500);
  });
}
